import { ApplicantStatus } from "shared/types";
import { cx } from "shared/utils";

export const VerificationProgress = ({
  totalVerifications = 0,
  completedVerifications = 0,
  status,
  className
}: {
  totalVerifications: number;
  completedVerifications: number;
  status: ApplicantStatus;
  className?: string;
}) => {
  const isCanceled = status === ApplicantStatus.Canceled;
  const isSubmitted = status === ApplicantStatus.Submitted;

  const getTrackBg = () => {
    if (isSubmitted) return "bg-success-50";
    if (isCanceled) return "bg-alpha-40";
    return "bg-primary-20";
  };

  const getBarBg = () => {
    if (isSubmitted) return "bg-success-500";
    if (isCanceled) return "bg-alpha-300";
    return "bg-primary-500";
  };

  const getProgressWidth = () => {
    if (status === ApplicantStatus.Submitted) return "100%";

    if (status === ApplicantStatus.Finished) return "95%";

    if (totalVerifications > 0)
      return `${Math.max(
        0,
        Math.min(100, (completedVerifications / totalVerifications) * 100)
      )}%`;

    return "0%";
  };

  return (
    <div className={cx(className, "h-2 rounded w-full", getTrackBg())}>
      <div
        className={cx("h-2 rounded", getBarBg())}
        style={{
          width: getProgressWidth()
        }}
      />
    </div>
  );
};
